unit View.Nfe_Lote.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewNfe_LoteEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbaliado_id: TLabel;
    edaliado_id: TDBEdit;
    lbdata_base_id: TLabel;
    eddata_base_id: TDBEdit;
    lbemissao: TLabel;
    edemissao: TDBEdit;
    lbcodigo: TLabel;
    edcodigo: TDBEdit;
    lbquantidade_nfe: TLabel;
    edquantidade_nfe: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientNfe_LoteGet: TXDataWebClient;
    XDataClientNfe_LoteDelete: TXDataWebClient;
    Nfe_LoteDataset: TXDataWebDataSet;
    Nfe_LoteDatasetid: TIntegerField;
    Nfe_LoteDatasetaliado_id: TIntegerField;
    Nfe_LoteDatasetdata_base_id: TIntegerField;
    Nfe_LoteDatasetemissao: TDateTimeField;
    Nfe_LoteDatasetcodigo: TStringField;
    Nfe_LoteDatasetquantidade_nfe: TIntegerField;
    Nfe_LoteDatasetcodigo_interno: TIntegerField;
    Nfe_LoteDatasetexcluido: TBooleanField;
    Nfe_LoteDatasetinclusao: TDateTimeField;
    Nfe_LoteDatasetalteracao: TDateTimeField;
    Nfe_LoteDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientNfe_LoteGetLoad(Response: TXDataClientResponse);
    procedure XDataClientNfe_LoteDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientNfe_LoteDeleteError(Error: TXDataClientError);
    procedure Nfe_LoteDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewNfe_LoteEdit: TFViewNfe_LoteEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewNfe_LoteEdit }

procedure TFViewNfe_LoteEdit.btSaveClick(Sender: TObject);
begin
  if Nfe_LoteDataset.State in dsEditModes then
  begin
        Nfe_LoteDataset.Post;
    Nfe_LoteDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewNfe_LoteEdit.btDeleteClick(Sender: TObject);
begin
  if Nfe_LoteDataset.State in dsEditModes then
    Nfe_LoteDataset.Post;
  XDataClientNfe_LoteDelete.Delete(Nfe_LoteDataset.EntitySetName,
    TJSObject(Nfe_LoteDataset.CurrentData));
end;


class function TFViewNfe_LoteEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewNfe_LoteEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewNfe_LoteEdit.InsertEntity;
begin
  Nfe_LoteDataset.Close;
  Nfe_LoteDataset.SetJsonData('{}');
  Nfe_LoteDataset.Open;
  Nfe_LoteDataset.Insert;
end;

class function TFViewNfe_LoteEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewNfe_LoteEdit(AForm).FInserting := AInserting;
    TFViewNfe_LoteEdit(AForm).FId := AId;
    TFViewNfe_LoteEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewNfe_LoteEdit(AForm).InsertEntity
    else
      TFViewNfe_LoteEdit(AForm).LoadEntity;
    TFViewNfe_LoteEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewNfe_LoteEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewNfe_LoteEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Nfe_LoteDataset.Connection.Model.DefaultSchema.FindEntityType(
      Nfe_LoteDataset.EntitySetName
    )
  );
  XDataClientNfe_LoteGet.Get(Nfe_LoteDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewNfe_LoteEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewNfe_LoteEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewNfe_LoteEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewNfe_LoteEdit.XDataClientNfe_LoteGetLoad(Response: TXDataClientResponse);
begin
  Nfe_LoteDataset.Close;
  Nfe_LoteDataset.SetJsonData(Response.Result);
  Nfe_LoteDataset.Open;
  
  Nfe_LoteDataset.Edit;  
end;

procedure TFViewNfe_LoteEdit.XDataClientNfe_LoteDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewNfe_LoteEdit.XDataClientNfe_LoteDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewNfe_LoteEdit.Nfe_LoteDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewNfe_LoteEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewNfe_LoteEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.nfe_lote.form.message');
  lbMessage := TLabel.Create('view.nfe_lote.form.message.label');
  btCloseMessage := TButton.Create('view.nfe_lote.form.message.button');
  btCancel := TButton.Create('view.nfe_lote.form.btBack');
  btSave := TButton.Create('view.nfe_lote.form.btSave');
  btDelete := TButton.Create('view.nfe_lote.form.btDelete');
  lbid := TLabel.Create('view.nfe_lote.form.lbid');
  edid := TDBEdit.Create('view.nfe_lote.form.edid');
  lbaliado_id := TLabel.Create('view.nfe_lote.form.lbaliado_id');
  edaliado_id := TDBEdit.Create('view.nfe_lote.form.edaliado_id');
  lbdata_base_id := TLabel.Create('view.nfe_lote.form.lbdata_base_id');
  eddata_base_id := TDBEdit.Create('view.nfe_lote.form.eddata_base_id');
  lbemissao := TLabel.Create('view.nfe_lote.form.lbemissao');
  edemissao := TDBEdit.Create('view.nfe_lote.form.edemissao');
  lbcodigo := TLabel.Create('view.nfe_lote.form.lbcodigo');
  edcodigo := TDBEdit.Create('view.nfe_lote.form.edcodigo');
  lbquantidade_nfe := TLabel.Create('view.nfe_lote.form.lbquantidade_nfe');
  edquantidade_nfe := TDBEdit.Create('view.nfe_lote.form.edquantidade_nfe');
  lbcodigo_interno := TLabel.Create('view.nfe_lote.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.nfe_lote.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.nfe_lote.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.nfe_lote.form.edexcluido');
  lbinclusao := TLabel.Create('view.nfe_lote.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.nfe_lote.form.edinclusao');
  lbalteracao := TLabel.Create('view.nfe_lote.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.nfe_lote.form.edalteracao');
  lbexclusao := TLabel.Create('view.nfe_lote.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.nfe_lote.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Nfe_LoteDataset := TXDataWebDataSet.Create(Self);
  Nfe_LoteDatasetid := TIntegerField.Create(Self);
  Nfe_LoteDatasetaliado_id := TIntegerField.Create(Self);
  Nfe_LoteDatasetdata_base_id := TIntegerField.Create(Self);
  Nfe_LoteDatasetemissao := TDateTimeField.Create(Self);
  Nfe_LoteDatasetcodigo := TStringField.Create(Self);
  Nfe_LoteDatasetquantidade_nfe := TIntegerField.Create(Self);
  Nfe_LoteDatasetcodigo_interno := TIntegerField.Create(Self);
  Nfe_LoteDatasetexcluido := TBooleanField.Create(Self);
  Nfe_LoteDatasetinclusao := TDateTimeField.Create(Self);
  Nfe_LoteDatasetalteracao := TDateTimeField.Create(Self);
  Nfe_LoteDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientNfe_LoteGet := TXDataWebClient.Create(Self);
  XDataClientNfe_LoteDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbaliado_id.BeforeLoadDFMValues;
  edaliado_id.BeforeLoadDFMValues;
  lbdata_base_id.BeforeLoadDFMValues;
  eddata_base_id.BeforeLoadDFMValues;
  lbemissao.BeforeLoadDFMValues;
  edemissao.BeforeLoadDFMValues;
  lbcodigo.BeforeLoadDFMValues;
  edcodigo.BeforeLoadDFMValues;
  lbquantidade_nfe.BeforeLoadDFMValues;
  edquantidade_nfe.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Nfe_LoteDataset.BeforeLoadDFMValues;
  Nfe_LoteDatasetid.BeforeLoadDFMValues;
  Nfe_LoteDatasetaliado_id.BeforeLoadDFMValues;
  Nfe_LoteDatasetdata_base_id.BeforeLoadDFMValues;
  Nfe_LoteDatasetemissao.BeforeLoadDFMValues;
  Nfe_LoteDatasetcodigo.BeforeLoadDFMValues;
  Nfe_LoteDatasetquantidade_nfe.BeforeLoadDFMValues;
  Nfe_LoteDatasetcodigo_interno.BeforeLoadDFMValues;
  Nfe_LoteDatasetexcluido.BeforeLoadDFMValues;
  Nfe_LoteDatasetinclusao.BeforeLoadDFMValues;
  Nfe_LoteDatasetalteracao.BeforeLoadDFMValues;
  Nfe_LoteDatasetexclusao.BeforeLoadDFMValues;
  XDataClientNfe_LoteGet.BeforeLoadDFMValues;
  XDataClientNfe_LoteDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewNfe_LoteEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 562;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 502;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 502;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 502;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbaliado_id.SetParentComponent(Self);
    lbaliado_id.Name := 'lbaliado_id';
    lbaliado_id.Left := 24;
    lbaliado_id.Top := 219;
    lbaliado_id.Width := 14;
    lbaliado_id.Height := 13;
    lbaliado_id.Caption := 'aliado_id:';
    lbaliado_id.Transparent := True;
    edaliado_id.SetParentComponent(Self);
    edaliado_id.Name := 'edaliado_id';
    edaliado_id.Left := 221;
    edaliado_id.Top := 216;
    edaliado_id.Width := 200;
    edaliado_id.Height := 21;
    edaliado_id.Enabled := True;
    edaliado_id.TabOrder := 7;
    edaliado_id.Text := 'edaliado_id';
    edaliado_id.DataField := 'aliado_id';
    edaliado_id.DataSource := DataSource;
    lbdata_base_id.SetParentComponent(Self);
    lbdata_base_id.Name := 'lbdata_base_id';
    lbdata_base_id.Left := 24;
    lbdata_base_id.Top := 246;
    lbdata_base_id.Width := 14;
    lbdata_base_id.Height := 13;
    lbdata_base_id.Caption := 'data_base_id:';
    lbdata_base_id.Transparent := True;
    eddata_base_id.SetParentComponent(Self);
    eddata_base_id.Name := 'eddata_base_id';
    eddata_base_id.Left := 221;
    eddata_base_id.Top := 243;
    eddata_base_id.Width := 200;
    eddata_base_id.Height := 21;
    eddata_base_id.Enabled := True;
    eddata_base_id.TabOrder := 8;
    eddata_base_id.Text := 'eddata_base_id';
    eddata_base_id.DataField := 'data_base_id';
    eddata_base_id.DataSource := DataSource;
    lbemissao.SetParentComponent(Self);
    lbemissao.Name := 'lbemissao';
    lbemissao.Left := 24;
    lbemissao.Top := 273;
    lbemissao.Width := 14;
    lbemissao.Height := 13;
    lbemissao.Caption := 'emissao:';
    lbemissao.Transparent := True;
    edemissao.SetParentComponent(Self);
    edemissao.Name := 'edemissao';
    edemissao.Left := 221;
    edemissao.Top := 270;
    edemissao.Width := 200;
    edemissao.Height := 21;
    edemissao.Enabled := True;
    edemissao.TabOrder := 9;
    edemissao.Text := 'edemissao';
    edemissao.DataField := 'emissao';
    edemissao.DataSource := DataSource;
    lbcodigo.SetParentComponent(Self);
    lbcodigo.Name := 'lbcodigo';
    lbcodigo.Left := 24;
    lbcodigo.Top := 300;
    lbcodigo.Width := 14;
    lbcodigo.Height := 13;
    lbcodigo.Caption := 'codigo:';
    lbcodigo.Transparent := True;
    edcodigo.SetParentComponent(Self);
    edcodigo.Name := 'edcodigo';
    edcodigo.Left := 221;
    edcodigo.Top := 297;
    edcodigo.Width := 200;
    edcodigo.Height := 21;
    edcodigo.Enabled := True;
    edcodigo.TabOrder := 10;
    edcodigo.Text := 'edcodigo';
    edcodigo.DataField := 'codigo';
    edcodigo.DataSource := DataSource;
    lbquantidade_nfe.SetParentComponent(Self);
    lbquantidade_nfe.Name := 'lbquantidade_nfe';
    lbquantidade_nfe.Left := 24;
    lbquantidade_nfe.Top := 327;
    lbquantidade_nfe.Width := 14;
    lbquantidade_nfe.Height := 13;
    lbquantidade_nfe.Caption := 'quantidade_nfe:';
    lbquantidade_nfe.Transparent := True;
    edquantidade_nfe.SetParentComponent(Self);
    edquantidade_nfe.Name := 'edquantidade_nfe';
    edquantidade_nfe.Left := 221;
    edquantidade_nfe.Top := 324;
    edquantidade_nfe.Width := 200;
    edquantidade_nfe.Height := 21;
    edquantidade_nfe.Enabled := True;
    edquantidade_nfe.TabOrder := 11;
    edquantidade_nfe.Text := 'edquantidade_nfe';
    edquantidade_nfe.DataField := 'quantidade_nfe';
    edquantidade_nfe.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 354;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 351;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 12;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 381;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 378;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 13;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 408;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 405;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 14;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 435;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 432;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 15;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 462;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 459;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 16;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Nfe_LoteDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Nfe_LoteDataset.SetParentComponent(Self);
    Nfe_LoteDataset.Name := 'Nfe_LoteDataset';
    Nfe_LoteDataset.AfterApplyUpdates := Nfe_LoteDatasetAfterApplyUpdates;
    Nfe_LoteDataset.EntitySetName := 'Nfe_Lote';
    Nfe_LoteDataset.Connection := DMConnection.ApiConnection;
    Nfe_LoteDataset.Left := 176;
    Nfe_LoteDataset.Top := 8;
    Nfe_LoteDatasetid.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetid.Name := 'Nfe_LoteDatasetid';
    Nfe_LoteDatasetid.FieldName := 'id';
    Nfe_LoteDatasetid.Required := True;
    Nfe_LoteDatasetaliado_id.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetaliado_id.Name := 'Nfe_LoteDatasetaliado_id';
    Nfe_LoteDatasetaliado_id.FieldName := 'aliado_id';
    Nfe_LoteDatasetaliado_id.Required := True;
    Nfe_LoteDatasetdata_base_id.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetdata_base_id.Name := 'Nfe_LoteDatasetdata_base_id';
    Nfe_LoteDatasetdata_base_id.FieldName := 'data_base_id';
    Nfe_LoteDatasetdata_base_id.Required := True;
    Nfe_LoteDatasetemissao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetemissao.Name := 'Nfe_LoteDatasetemissao';
    Nfe_LoteDatasetemissao.FieldName := 'emissao';
    Nfe_LoteDatasetemissao.Required := False;
    Nfe_LoteDatasetcodigo.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetcodigo.Name := 'Nfe_LoteDatasetcodigo';
    Nfe_LoteDatasetcodigo.FieldName := 'codigo';
    Nfe_LoteDatasetcodigo.Required := False;
    Nfe_LoteDatasetcodigo.Size := 255;
    Nfe_LoteDatasetquantidade_nfe.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetquantidade_nfe.Name := 'Nfe_LoteDatasetquantidade_nfe';
    Nfe_LoteDatasetquantidade_nfe.FieldName := 'quantidade_nfe';
    Nfe_LoteDatasetquantidade_nfe.Required := False;
    Nfe_LoteDatasetcodigo_interno.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetcodigo_interno.Name := 'Nfe_LoteDatasetcodigo_interno';
    Nfe_LoteDatasetcodigo_interno.FieldName := 'codigo_interno';
    Nfe_LoteDatasetcodigo_interno.Required := True;
    Nfe_LoteDatasetexcluido.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetexcluido.Name := 'Nfe_LoteDatasetexcluido';
    Nfe_LoteDatasetexcluido.FieldName := 'excluido';
    Nfe_LoteDatasetexcluido.Required := False;
    Nfe_LoteDatasetinclusao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetinclusao.Name := 'Nfe_LoteDatasetinclusao';
    Nfe_LoteDatasetinclusao.FieldName := 'inclusao';
    Nfe_LoteDatasetinclusao.Required := False;
    Nfe_LoteDatasetalteracao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetalteracao.Name := 'Nfe_LoteDatasetalteracao';
    Nfe_LoteDatasetalteracao.FieldName := 'alteracao';
    Nfe_LoteDatasetalteracao.Required := False;
    Nfe_LoteDatasetexclusao.SetParentComponent(Nfe_LoteDataset);
    Nfe_LoteDatasetexclusao.Name := 'Nfe_LoteDatasetexclusao';
    Nfe_LoteDatasetexclusao.FieldName := 'exclusao';
    Nfe_LoteDatasetexclusao.Required := False;
    XDataClientNfe_LoteGet.SetParentComponent(Self);
    XDataClientNfe_LoteGet.Name := 'XDataClientNfe_LoteGet';
    XDataClientNfe_LoteGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNfe_LoteGet, Self, 'OnLoad', 'XDataClientNfe_LoteGetLoad');
    XDataClientNfe_LoteGet.Left := 64;
    XDataClientNfe_LoteGet.Top := 8;
    XDataClientNfe_LoteDelete.SetParentComponent(Self);
    XDataClientNfe_LoteDelete.Name := 'XDataClientNfe_LoteDelete';
    XDataClientNfe_LoteDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientNfe_LoteDelete, Self, 'OnLoad', 'XDataClientNfe_LoteDeleteLoad');
    SetEvent(XDataClientNfe_LoteDelete, Self, 'OnError', 'XDataClientNfe_LoteDeleteError');
    XDataClientNfe_LoteDelete.Left := 64;
    XDataClientNfe_LoteDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbaliado_id.AfterLoadDFMValues;
    edaliado_id.AfterLoadDFMValues;
    lbdata_base_id.AfterLoadDFMValues;
    eddata_base_id.AfterLoadDFMValues;
    lbemissao.AfterLoadDFMValues;
    edemissao.AfterLoadDFMValues;
    lbcodigo.AfterLoadDFMValues;
    edcodigo.AfterLoadDFMValues;
    lbquantidade_nfe.AfterLoadDFMValues;
    edquantidade_nfe.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Nfe_LoteDataset.AfterLoadDFMValues;
    Nfe_LoteDatasetid.AfterLoadDFMValues;
    Nfe_LoteDatasetaliado_id.AfterLoadDFMValues;
    Nfe_LoteDatasetdata_base_id.AfterLoadDFMValues;
    Nfe_LoteDatasetemissao.AfterLoadDFMValues;
    Nfe_LoteDatasetcodigo.AfterLoadDFMValues;
    Nfe_LoteDatasetquantidade_nfe.AfterLoadDFMValues;
    Nfe_LoteDatasetcodigo_interno.AfterLoadDFMValues;
    Nfe_LoteDatasetexcluido.AfterLoadDFMValues;
    Nfe_LoteDatasetinclusao.AfterLoadDFMValues;
    Nfe_LoteDatasetalteracao.AfterLoadDFMValues;
    Nfe_LoteDatasetexclusao.AfterLoadDFMValues;
    XDataClientNfe_LoteGet.AfterLoadDFMValues;
    XDataClientNfe_LoteDelete.AfterLoadDFMValues;
  end;
end;

end.
